An identifier to ensure that multiple candidate process history items are not created on retries.

The identifier must be unique within the given candidate profile.
The same identifier must be provided when retrying after create failures.
